import React from "react";
import { useState, useEffect } from "react";
// import Tab from 'react-bootstrap/Tab';
// import Tabs from 'react-bootstrap/Tabs';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import {Container, Row, Col, Card} from "react-bootstrap";
import { Animated } from "react-animated-css";
import IndustryBlog from "./IndustryBlog";
import $ from 'jquery';
import TabIcon1 from "../assets/images/icons/ind_medical_device_icn.svg";
import { industrytabAPI, industrytabNewAPI } from "../API/industryAPI";


import { useSearchParams } from "react-router-dom";
const IndustryTab = () => {
  const [searchParams] = useSearchParams();
    const [tabIndex, setTabIndex] = useState(window.location.href.split("=")[1]);
    
    const [industrydata, setindustryData] = useState([]);
    const [tabHeader, settabHeader] = useState([]);
    const [paneltitle, setpaneltitle] = useState([]);
    const [tabCount,settabCount] =useState([]);
    const [countData,setcountData] =useState([0]);
    const headTab=[];
    const count=[];
    
    const contentTitle=[];
    // $(document).ready(function(){
    //   if ($this.attr("id") == "tab:r1:"+0) {
    //     $("#myTbl").removeClass("myClass");
    // }
    // });
    $(document).ready(function(){
      $('[data-toggle="tooltip"]').tooltip();   
    });

  useEffect(() => { 
    // console.log(Number(window.location.href.split("=")[1]),"lo")
    // const num=Number(window.location.href.split("=")[1])
    // setTabIndex(num)
    var config = { "Access-Control-Allow-Origin": "*" }
    industrytabNewAPI(config, (response) => {
    //success
    const industrycontent = response.data.map(item => item.contentElements);
    const industrysubcontent = industrycontent[0].map(item => item.contentElementsPart1);
    const industryTabpanel = industrycontent[0].map(item => item.contentElementsPart2);
    setindustryData(industryTabpanel);
    setindustryData(industrysubcontent);
    for(let i=0;i<industrycontent.length;i++)
                {
                  headTab.push(industrysubcontent[i].map(list=> list));
                  contentTitle.push(industryTabpanel[i].map(list=> list));
                }
    for(let j=0;j<contentTitle[0].length;j++)                {
        count.push(j+3);
    }
   // console.log("industry data",contentTitle[0]);
    settabHeader(headTab[0]);
    settabCount(countData);
    
    setpaneltitle(contentTitle[0]);
    },(err) => {
        //error
        console.log(err);
    });
      
  }, []);

  useEffect(()=>{
    console.log(searchParams?.get("step"))
    setTabIndex(Number(searchParams?.get("step")))
        },[searchParams])
  //console.log("count data",tabCount);
  const cardcount = {tabCount};
console.log(tabIndex,"ini")
return (
  <div className="bics-industry-tab py-3 py-md-5 py-lg-5">
    <Container>
      <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
        <TabList>
        {tabHeader.map((item, index) => (
          <Tab key={index} data-toggle="tooltip" title={item.ElementTittle}>
            <span>
              <img src={process.env.REACT_APP_BASE_URL + item.ElementLogo} alt="tab-icon" className="tab-icon" />
            </span>
            <span className="industry_tab_title" >{item.ElementTittle}</span>
          </Tab>
          ))}
        </TabList>
        {paneltitle.map((item, index) => (
        <TabPanel key={index}>
          <Animated
            animationIn="fadeInUp"
            animationOut="fadeOutUp"
            animationInDuration={1000}
            animationInDelay={100}
            animationOutDelay={100}
            isVisible={true}
          >
            <Row className="my-3 my-md-4 my-lg-4 my-xl-5">
              <Col xs={12} md={6}>
                <Card className="bics-industry-card">
                  <Card.Body>
                    <Card.Title>
                      <span>
                        <img
                          src={process.env.REACT_APP_BASE_URL + item.ElementLogo1}
                          alt="tab-icon"
                          className="tab-icon industry_icon"
                        />
                      </span>{" "}
                      {item.ElementTittle}
                    </Card.Title>

                    <Card.Text>
                      {item.ElementDescription}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col xs={12} md={6}>
              <Animated
            animationIn="slideInLeft"
            animationOut="fadeOutUp"
            animationInDuration={1000}
            animationInDelay={100}
            isVisible={true}
            className="backdrop-box"
          >
              <img
                          src={process.env.REACT_APP_BASE_URL + item.ElementLogo2}
                          alt="tab-icon"
                          className="tab-icon w-100 tab-section-img"
                        />
              </Animated>
              </Col>
            </Row>
            <Row>
            <Col xs={12} md={12}>
                <div className="bics-indus-block-section">
                     <IndustryBlog data={tabIndex}/>
                </div>
            </Col>
            </Row>
          </Animated>

        </TabPanel>
        ))}
      </Tabs>
    </Container>
  </div>
);
}

export default IndustryTab;